const brickCreationScriptBlue = `
  const unmountWalletBrick = async () => {
    if (window.walletBrickController) {
      try {
        await window.walletBrickController.unmount();
        window.walletBrickController = null;
      } catch (error) {
        console.error('Error during unmount:', error);
      }
    }
  };

  unmountWalletBrick();

  const mp = new MercadoPago(window.walletBricksProps.publicKey, {
    locale: window.walletBricksProps.language,
    trackingDisabled: true
  });
  const bricksBuilder = mp.bricks({theme: window.walletBricksProps.theme});
  const renderWalletBrick = async (bricksBuilder) => {

    const settings = {
      initialization: {
        redirectMode: window.walletBricksProps.redirectMode,
        preferenceId: window.walletBricksProps.preferenceId,
      },
      callbacks: {
        onReady: () => {
          // callback chamado quando o Brick estiver pronto
          // dispatchEvent(new Event('walletBrickReady'));
        },
        onSubmit: (cardFormData) => {
        },
        onError: (error) => {
          // callback chamado para todos os casos de erro do Brick
        },
      },
      customization: {
        texts: {
          action: window.walletBricksProps.action,
          valueProp: window.walletBricksProps.valueProp,
        },
        checkout: {
          theme: {
            elementsColor: window.walletBricksProps.elementsColor,
            headerColor: window.walletBricksProps.headerColor
          },
        },
        visual: window.walletBricksProps.styleProperties,
      },
    };
    window.walletBrickController = await bricksBuilder.create('wallet', 'walletBrick_container', settings);
  };
  renderWalletBrick(bricksBuilder);
  `;

const brickCreationScriptYellow = `
  const unmountWalletBrick = async () => {
    if (window.walletBrickController) {
      try {
        await window.walletBrickController.unmount();
        window.walletBrickController = null;
      } catch (error) {
        console.error('Error during unmount:', error);
      }
    }
  };

  unmountWalletBrick();

  const mp = new MercadoPago(window.walletBricksProps.publicKey, {
    locale: window.walletBricksProps.language,
    trackingDisabled: true
  });
  const bricksBuilder = mp.bricks({theme: window.walletBricksProps.theme});
  const renderWalletBrick = async (bricksBuilder) => {

    const settings = {
      initialization: {
        redirectMode: window.walletBricksProps.redirectMode,
        preferenceId: window.walletBricksProps.preferenceId,
      },
      callbacks: {
        onReady: () => {
          // callback chamado quando o Brick estiver pronto
          // dispatchEvent(new Event('walletBrickReady'));
        },
        onSubmit: (cardFormData) => {
        },
        onError: (error) => {
          // callback chamado para todos os casos de erro do Brick
        },
      },
      customization: {        
        valueProp: window.walletBricksProps.valueProp,
        theme: window.walletBricksProps.theme,
        checkout: {
          theme: {
            elementsColor: window.walletBricksProps.elementsColor,
            headerColor: window.walletBricksProps.headerColor
          },
        },
        customStyle: window.walletBricksProps.styleProperties,
      },
    };
    window.walletBrickController = await bricksBuilder.create('wallet', 'walletBrick_container', settings);
  };
  renderWalletBrick(bricksBuilder);
  `;

const testCredentials = [
  {
    publicKey: 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d',
    accessToken: 'TEST-7434002853288159-031415-e93f0f4cee51edf8c90ff795af94f589-1322442691',
    siteId: 'MLB',
    yellowPublicKey: 'APP_USR-67d1f9a0-8f72-4b03-b311-efa78d5ba023',
    yellowAccessToken: 'APP_USR-4446652208680928-012112-d77b23913e73e1d81b27ee97b7d0670b-1980725732',
  },
  {
    publicKey: 'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b',
    accessToken: 'TEST-4599991948843755-112216-0171268d497ae962d904f4a27ecf8d85-1245621468',
    siteId: 'MLA',
    yellowPublicKey: 'APP_USR-295faec0-4362-43a4-b665-878874829514',
    yellowAccessToken: 'APP_USR-7941338808442311-012112-802c012a68a064c058877ab2e1bd33bb-1980725730',
  },
  {
    publicKey: 'TEST-7094fa90-db4e-4dc1-82ed-54072977aae5',
    accessToken: 'TEST-3322631766806190-030312-1cd04b846528954cf9acbb4ba0339910-1322460166',
    siteId: 'MLU',
    yellowPublicKey: 'APP_USR-a506306c-80bf-427b-95a6-635261347780',
    yellowAccessToken: 'APP_USR-528007632655441-012112-f249fd555ad1ea04f2f62a90c1d51d6c-1987966104',
  },
  {
    publicKey: 'TEST-36ac5e4f-11ca-4152-93fa-1e90d870ad13',
    accessToken: 'TEST-7719716762635832-031414-b2f72b0ec93098549c6616b21f1e54b5-1269022120',
    siteId: 'MLC',
    yellowPublicKey: 'APP_USR-57fb41be-320d-4269-af07-7191bbc11441',
    yellowAccessToken: 'APP_USR-6600480123018687-012112-3c3187d53ef11ffdf62cab682a1b836e-1976745789',
  },
  {
    publicKey: 'TEST-852eef7f-952a-43ca-887f-19780ecf8ed8',
    accessToken: 'TEST-8971847217814918-011912-8ad91745874530a4ca8b8992d4799fdf-1283156318',
    siteId: 'MLM',
    yellowPublicKey: 'APP_USR-85264640-5570-48d1-86b1-8c2d69f55ab6',
    yellowAccessToken: 'APP_USR-1886848718269103-012112-2dbb20dfa93149ae56702c09f505cea0-1980725734',
  },
  {
    publicKey: 'TEST-af696d89-c335-4cc1-982c-af28f38e7894',
    accessToken: 'TEST-5599114831530291-021714-7a29539139a4791edcd709f06f7f5835-1312670102',
    siteId: 'MCO',
    yellowPublicKey: 'APP_USR-16c4c2a3-ccf3-48fa-bc0a-fbb3adf1a93a',
    yellowAccessToken: 'APP_USR-1927181920172865-012112-e859bcccb58ab690d08854cff3bfb9d2-1987966114',
  },
  {
    publicKey: 'TEST-513b4541-d1e6-419b-9cf2-23dc290669ad',
    accessToken: 'TEST-2151654715776762-030312-3442d75750b665b753ab6d2034dac477-1322465684',
    siteId: 'MPE',
    yellowPublicKey: 'APP_USR-b978c8f8-e962-436b-a103-f3beaf0edced',
    yellowAccessToken: 'APP_USR-1247538448013604-012112-393ebf356966a4288231f311163569c9-1987966110',
  },
];

module.exports = { brickCreationScriptBlue, brickCreationScriptYellow, testCredentials };
